import React from 'react';

const Footer = () => {
  return (
    <footer className="footer bar">
      <p>Traveln &copy; {new Date().getFullYear()}</p>
    </footer>
  );
};
export default Footer;
